import '@babel/polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import JsonExcel from 'vue-json-excel'
import moment from 'moment'
import VueBootstrapDatetimePicker from 'vue-bootstrap-datetimepicker'
Vue.use(BootstrapVue)
moment.updateLocale('ru')
Vue.component('downloadExcel', JsonExcel)
Vue.component('date-picker', VueBootstrapDatetimePicker)
Vue.config.productionTip = false
// const REQ_PATH = 'http://localhost:5000'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js